import { render, staticRenderFns } from "./MaximumBenefit.vue?vue&type=template&id=9160eed6&scoped=true"
import script from "./MaximumBenefit.vue?vue&type=script&lang=js"
export * from "./MaximumBenefit.vue?vue&type=script&lang=js"
import style0 from "./MaximumBenefit.vue?vue&type=style&index=0&id=9160eed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160eed6",
  null
  
)

export default component.exports